module.exports = __webpack_public_path__ + "static/img/031治疗单-医生.cdebfcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/031治疗单-医生.jpg
// module id = k0GR
// module chunks = 0